import type { Swiper as SwiperClass } from "swiper";

/**
 * Resolves swipe direction after a settled transition.
 * Uses Swiper's swipeDirection when available (required for loop wrap-around).
 */
export function getSettledSlideDirection(
  swiper: SwiperClass,
  previousRealIndex: number
): "prev" | "next" | null {
  const activeIndex = swiper.realIndex;
  if (activeIndex === previousRealIndex) {
    return null;
  }
  if (swiper.swipeDirection === "prev" || swiper.swipeDirection === "next") {
    return swiper.swipeDirection;
  }
  return activeIndex > previousRealIndex ? "next" : "prev";
}
